import React from 'react'
import Sala from '../Sala'
import VerticalConnection from '../Connections/VerticalConnection'
import HorizontalConnection from '../Connections/HorizontalConnection'
import DiagonalConnectionOne from '../Connections/DiagonalConnectionOne'
import DiagonalConnectionTwo from '../Connections/DiagonalConnectionTwo'
//import VerticalConnection2 from '../Connections2/VerticalConnection2'
//import HorizontalConnection2 from '../Connections2/HorizontalConnection2'
// import DiagonalConnection2One from '../Connections2/DiagonalConnection2One'
// import DiagonalConnection2Two from '../Connections2/DiagonalConnection2Two'
import { useState } from "react"
import Animacao from '../Animacao'
import Modal from '../Modal';
import {getNodesId} from '../Animacao';

export const Cenario2 = ({ start, distancesC2, showModal, algorithm }) => { 
    const [startNode, setStartNode] = useState(0)
    const idCenario = 2

    /*const chooseStartNode = (id) => { 
        document.getElementById(id.toString()).children.item(0).setAttribute("class", "startNode-cenario2");
        setStartNode(id);
    } */

    const clearAndStart = (startNodeId) => {   
        document.getElementById('alert-achou-caminho').setAttribute("style", "display:none");
        if(start === true) { //limpa cenário apenas se estiver 'sujo'
            var nodesInShortestPathOrder = getNodesId()
            if(nodesInShortestPathOrder !== undefined && nodesInShortestPathOrder !== null)
                clearNodesConnections(nodesInShortestPathOrder)
        } 
        setStartNode(startNodeId)
    }
      
    const clearNodesConnections = (nodesInShortestPathOrder) => {
        var classNameOrig, classNameConnectionV, classNameConnectionH, classNameConnectionD1, classNameConnectionD2
        classNameOrig = 'sala-cenario2'
        classNameConnectionV = 'vertical-connection-cenario2'
        classNameConnectionH = 'horizontal-connection-cenario2'
        classNameConnectionD1 = 'diagonal-connection-one-cenario2'
        classNameConnectionD2 = 'diagonal-connection-two-cenario2'
      
        for (let i = 0; i < nodesInShortestPathOrder.length; i++) {
          //Limpar salas
          const node = nodesInShortestPathOrder[i];
          document.getElementById(`${node}`).children.item(0).className = classNameOrig;
      
          //Limpar connections
          if(i !== nodesInShortestPathOrder.length - 1) { 
            let node1 = nodesInShortestPathOrder[i];
            let node2 = nodesInShortestPathOrder[i+1];
            if (node1 > node2) {
              let aux = node1;
              node1 = node2;
              node2 = aux;
            }
            const connectionId = parseInt('1' + node1.toString() + node2.toString(), 10);
            const connectionType = document.getElementById(`${connectionId}`).children.item(0).id;
           if(connectionType === '111') {
              document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionV;
            } else if(connectionType === '222') {
              document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionH;
            } else if(connectionType === '333') {
              document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionD1;
            } else if(connectionType === '444') {
              document.getElementById(`${connectionId}`).children.item(0).className = classNameConnectionD2;
            }           
          }
        }
    }
    
    return (
        <>
            {/* CENÁRIO */} 
            <div> 
                <div id={0}><Sala idCenario={idCenario} onClick={() => clearAndStart(0)}/> </div>
                <div id={101}><VerticalConnection idCenario={idCenario} distance={distancesC2[0].toFixed(1)}/></div>
                <div id={1}><Sala idCenario={idCenario} onClick={() => clearAndStart(1)}/> </div>
                <div id={112}><VerticalConnection idCenario={idCenario} distance={distancesC2[1].toFixed(1)}/></div>
                <div id={2}><Sala idCenario={idCenario} onClick={() => clearAndStart(2)}/> </div>
            </div>
            <div>
                <div id={103}><HorizontalConnection idCenario={idCenario} margemAcima={40} distance={distancesC2[2].toFixed(1)}/></div>
                {/* <div style={{ float: 'left'}}> <HorizontalConnection2/> </div> */}
                <div id={113}><DiagonalConnectionOne idCenario={idCenario} distance={distancesC2[3].toFixed(1)}/></div>               
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/>
                <div id={114}><DiagonalConnectionTwo idCenario={idCenario} distance={distancesC2[4].toFixed(1)}/></div>
                <div id={124}><HorizontalConnection idCenario={idCenario} distance={distancesC2[5].toFixed(1)}/></div>                
            </div>
            <div>
                <div id={3}><Sala idCenario={idCenario} onClick={() => clearAndStart(3)}/> </div>
                <Modal showModal={showModal} idCenario={idCenario}/>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>              
                <Sala idCenario={idCenario} isTransparente={true}/>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>

                <div id={4}><Sala idCenario={idCenario} onClick={() => clearAndStart(4)}/></div> 
            </div>
            <div>
                <div id={135}><HorizontalConnection idCenario={idCenario} margemAcima={40} distance={distancesC2[6].toFixed(1)}/></div>
                <div id={136}><DiagonalConnectionTwo idCenario={idCenario} distance={distancesC2[7].toFixed(1)}/></div>                   
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/> 
                <DiagonalConnectionOne idCenario={idCenario} isTransparente={true}/> 
                <div id={147}><HorizontalConnection idCenario={idCenario} distance={distancesC2[8].toFixed(1)}/> </div>              
            </div>
            <div>
                <div id={5}><Sala idCenario={idCenario} onClick={() => clearAndStart(5)}/></div> 
                <div id={156}><VerticalConnection idCenario={idCenario} distance={distancesC2[9].toFixed(1)}/></div>
                
                <div id={6}><Sala idCenario={idCenario} onClick={() => clearAndStart(6)}/> </div>
                <div id={167}><VerticalConnection idCenario={idCenario} distance={distancesC2[10].toFixed(1)}/></div>
               
                <div id={7}><Sala idCenario={idCenario} onClick={() => clearAndStart(7)}/> </div>
            </div>
            <div>
                <div id={158}><HorizontalConnection idCenario={idCenario} margemAcima={40} distance={distancesC2[11].toFixed(1)}/></div> 
                <div id={168}><DiagonalConnectionOne idCenario={idCenario} distance={distancesC2[12].toFixed(1)}/></div>  
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/>
                <div id={169}><DiagonalConnectionTwo idCenario={idCenario} distance={distancesC2[13].toFixed(1)}/></div> 
                <div id={179}><HorizontalConnection idCenario={idCenario} distance={distancesC2[14].toFixed(1)}/></div>               
            </div>
            <div>
                <div id={8}><Sala idCenario={idCenario} onClick={() => clearAndStart(8)}/></div> 
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
                
                <Sala idCenario={idCenario} isTransparente={true}/> 
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
                
                <div id={9}><Sala idCenario={idCenario} onClick={() => clearAndStart(9)}/></div>  
            </div>
            <div>
                <div id={1810}><HorizontalConnection idCenario={idCenario} margemAcima={40} distance={distancesC2[15].toFixed(1)}/></div>  
                <div id={1811}><DiagonalConnectionTwo idCenario={idCenario} distance={distancesC2[16].toFixed(1)}/></div>                   
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/> 
                <div id={1911}><DiagonalConnectionOne idCenario={idCenario} distance={distancesC2[17].toFixed(1)}/></div>                
            </div>
            <div>
                <div id={10}><Sala idCenario={idCenario} onClick={() => clearAndStart(10)}/> </div>
                <div id={11011}><VerticalConnection idCenario={idCenario} distance={distancesC2[18].toFixed(1)}/></div>
                
                <div id={11}><Sala idCenario={idCenario} onClick={() => clearAndStart(11)}/> </div>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
               
                <Sala idCenario={idCenario} isTransparente={true}/>
            </div>
            <div>
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/> 
                <div id={11012}><DiagonalConnectionTwo idCenario={idCenario} distance={distancesC2[19].toFixed(1)}/></div>                   
                <div id={11112}><HorizontalConnection idCenario={idCenario} distance={distancesC2[20].toFixed(1)}/></div>
                <div id={11113}><DiagonalConnectionTwo idCenario={idCenario} distance={distancesC2[21].toFixed(1)}/></div>                
            </div>
            <div>
                <Sala idCenario={idCenario} isTransparente={true}/> 
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
                
                <div id={12}><Sala idCenario={idCenario} onClick={() => clearAndStart(12)}/></div>
                <div id={11213}><VerticalConnection idCenario={idCenario} distance={distancesC2[22].toFixed(1)}/></div>

                <div id={13}><Sala idCenario={idCenario} onClick={() => clearAndStart(13)}/></div>
            </div>
            <div>
                <HorizontalConnection idCenario={idCenario} isTransparente={true}/>
                <DiagonalConnectionOne idCenario={idCenario} isTransparente={true}/>                   
                <div id={11214}><HorizontalConnection idCenario={idCenario} distance={distancesC2[23].toFixed(1)}/></div> 
                <div id={11314}><DiagonalConnectionOne idCenario={idCenario} distance={distancesC2[24].toFixed(1)}/></div>              
            </div>
            <div>
                <Sala idCenario={idCenario} isTransparente={true}/>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
                
                <div id={14}><Sala idCenario={idCenario} onClick={() => clearAndStart(14)}/> </div>
                <VerticalConnection idCenario={idCenario} isTransparente={true}/>
               
                <Sala idCenario={idCenario} isTransparente={true}/>
            </div>

            {/* COMEÇAR ANIMAÇÃO*/}
            {start && <Animacao start={start} startNode={startNode} idCenario={2} distances={distancesC2} algorithm={algorithm}/>}
        </>
    )
}

export default Cenario2